export const getNumberByKey = (
	objects: [{ [key: string]: number }] | undefined,
	partialKey?: string
) => {
	const b = partialKey ? objects?.find((obj) => obj[partialKey]) : null;

	if (b && partialKey) {
		return b[partialKey];
	}

	return 0;
};

export const getEnvironmentCode = () => {
	const url = window.location.host;

	if (url.includes('-dev')) {
		return '-dev';
	}
	if (url.includes('-stag')) {
		return '-staging';
	}
	if (url.includes('-cloud')) {
		return '-prod';
	}
	return '-local';
};
